import React from 'react';
import { FaEdit, FaPlane, FaTrain, FaCar, FaShip, FaBus, FaQuestion, FaFile } from 'react-icons/fa';

/**
 * Header component for travel detail display
 */
export const TravelHeader = ({ travel, onEdit, onDocumentUpload, children }) => {
    const { summary, status, type } = travel;

    // Get icon for travel type
    const getTravelIcon = (type) => {
        switch (type) {
            case 'flight': return <FaPlane />;
            case 'train': return <FaTrain />;
            case 'car': return <FaCar />;
            case 'cruise': return <FaShip />;
            case 'bus': return <FaBus />;
            default: return <FaQuestion />;
        }
    };

    // Capitalize the first letter
    const typeLabel = type.charAt(0).toUpperCase() + type.slice(1);

    return (
        <div className="travel-title-section">
            <div className="title-display">
                <h1>
                    <span className="travel-type-icon">{getTravelIcon(type)}</span>
                    {summary}
                    {onEdit && (
                        <button className="edit-button" onClick={onEdit}>
                            <FaEdit />
                        </button>
                    )}
                </h1>

                {/* Document Upload Button */}
                {onDocumentUpload && (
                    <button className="edit-button document-upload-button" onClick={onDocumentUpload}>
                        <FaFile /> Document Upload
                    </button>
                )}

                {/* Additional Actions (e.g. Link Entities) */}
                {children}
            </div>
        </div>
    );
};

export default TravelHeader;